import React from 'react';
import { observer } from 'mobx-react';
import { InventorySyncListTemplate } from 'themes/modules/product-inventory/pages';

@observer
class InventorySyncList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <InventorySyncListTemplate {...this.props} viewstore={this.props.inventorySyncPageViewStore} />;
	}
}

export default InventorySyncList;



// WEBPACK FOOTER //
// ./src/modules/product-inventory/pages/InventorySyncList.jsx